import React from "react";
import NightSky from "../../components/common/NightSky";
import PixelButton from "../../components/common/PixelButton";
import useAuth from "./hooks/useAuth";

const ROLE_LABEL = {
  teacher: "⚔️ مدرس",
  support: "🔭 پشتیبانی",
  admin:   "👑 ادمین",
  staff:   "🖥️ استاف",
};

/**
 * PendingApprovalPage
 * وقتی کاربری موقع ثبت‌نام یه نقش حساس (teacher/support/admin/staff)
 * انتخاب کرده ولی هنوز ادمین تأییدش نکرده، PrivateRoute به‌جای هر
 * صفحه‌ی دیگه‌ای همینو نشون می‌ده — نه پنل واقعی، نه حتی داشبورد دانشجویی.
 */
const PendingApprovalPage = () => {
  const { currentUser, logout } = useAuth();
  const roleLabel = ROLE_LABEL[currentUser?.pending_role] || currentUser?.pending_role || "درخواستی";

  return (
    <div className="auth-page" dir="rtl">
      <NightSky density="low" showMoon showClouds={false} />
      <div className="auth-container">

        <div style={{ textAlign:"center", display:"flex", flexDirection:"column", alignItems:"center", gap:6 }}>
          <div style={{ fontSize:"3rem" }}>⏳</div>
          <h1 style={{ fontFamily:"var(--font-pixel)", fontSize:"1rem", color:"var(--color-accent)",
            textShadow:"3px 3px 0 var(--color-accent-dark)", margin:0 }}>
            PIXEL EDU
          </h1>
        </div>

        <div className="auth-card">
          <div style={{ textAlign:"center", display:"flex", flexDirection:"column", gap:14 }}>
            <h2 style={{ fontFamily:"var(--font-pixel)", fontSize:"0.7rem", color:"var(--color-text)", margin:0 }}>
              درخواست عضویت شما در دست بررسی است
            </h2>

            <p style={{ fontFamily:"var(--font-pixel)", fontSize:"0.48rem",
              color:"var(--color-text-muted)", lineHeight:2.2, margin:0 }}>
              {currentUser?.full_name ? `${currentUser.full_name} عزیز، ` : ""}
              شما با نقش «{roleLabel}» ثبت‌نام کرده‌اید.
              <br />
              پس از تأیید مدیر سیستم، دسترسی کامل برای شما فعال خواهد شد.
              <br />
              تا آن زمان امکان استفاده از هیچ بخش دیگری از سیستم وجود ندارد.
            </p>

            <div style={{ background:"rgba(255,153,0,0.08)", boxShadow:"0 0 0 2px #ff990040",
              padding:"12px 16px", fontFamily:"var(--font-pixel)", fontSize:"0.42rem",
              color:"#ff9900", lineHeight:1.9 }}>
              ⏳ در انتظار تأیید — نیازی به کار دیگه‌ای نیست، فقط صبر کن.
            </div>

            <PixelButton variant="ghost" size="md" onClick={logout}>
              🚪 خروج از حساب
            </PixelButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalPage;